import React from 'react';
import { useSelector } from 'react-redux';
import CircleGraph from './CircleGraph';
import { MasterCircleGraphContainer, ChartConatiner } from './CircleGraphMain.css.js';
import { graphOrder } from 'utils/code';
import { classifyCriterionDataByModule } from 'utils/utils';

const CircleGraphMain = (props) => {
  const circleGraph = graphOrder[props.moduleScn].map((key) => {
    const data = props[key] && key === 'o2' ? props[key].toFixed(1) : props[key];
    const status = props[`${key}_status`];

    return (
      <ChartConatiner key={key}>
        <CircleGraph
          label={key}
          moduleScn={props.moduleScn}
          moduleIdx={props.moduleIdx}
          dataValue={data}
          status={status}
          criterion={classifyCriterionDataByModule(props.criterion[key], props.moduleIdx)}
        />
      </ChartConatiner>
    );
  });

  return <MasterCircleGraphContainer>{circleGraph}</MasterCircleGraphContainer>;
};

export default CircleGraphMain;
